import { map } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import {
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BasicInfo1Component } from './digigov/dg_core/basic-info1/basic-info1.component';
import { AppGenMainComponent } from './digigov/dg_core/app-gen/app-gen-main/app-gen-main.component';
import { UserRegistrationComponent } from './digigov/dg_components_test/user-registration/user-registration.component';

export interface ComponentLoader {
  loadChildren: () => Promise<any>;
}

@Injectable({ providedIn: 'root' })
export class ComponentLoaderService {
  constructor(
    private http: HttpClient,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {}
  components = {
    BasicInfo1Component: BasicInfo1Component,
    BasicInfo2Component: UserRegistrationComponent,
    UserRegistrationComponent: UserRegistrationComponent,
    AppGenMainComponent: AppGenMainComponent,
  };
  getComponent(component): any {
    return this.components[component];
  }

  instantiateComponent = (
    viewContainerRef: ViewContainerRef,
    componentName: string
  ): ComponentRef<unknown> => {
    if (componentName in this.components) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.components[componentName]
      );
      const componentRef = viewContainerRef.createComponent(componentFactory);
      return componentRef;
    }
    return null;
  };

  instantiateComponentSync = (
    viewContainerRef: ViewContainerRef,
    component: Type<unknown>
  ): ComponentRef<unknown> => {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      component
    );
    const componentRef = viewContainerRef.createComponent(componentFactory);
    return componentRef;
  };

  instantiateComponentAsync = (
    viewContainerRef: ViewContainerRef,
    componentLoader: ComponentLoader
  ): Observable<ComponentRef<unknown>> =>
    from(componentLoader.loadChildren()).pipe(
      map((component) =>
        this.componentFactoryResolver.resolveComponentFactory(component)
      ),
      map((componentFactory) =>
        viewContainerRef.createComponent(componentFactory)
      )
    );
}
